import React from 'react';

import CartComponent from '../components/cart/Cart';
import Layout from '../components/layout/Layout';

const Cart = () => {
    return (
        <Layout>
            <CartComponent />
        </Layout>
    );
}

export default Cart;
